import api from '../utils/api';

// Fetch all parents
export const getAllParents = async (headers) => {
  try {
    const response = await api.get('/api/parents',  headers ); 
    return response.data;
  } catch (error) {
    console.error('Error fetching all parents:', error.response ? error.response.data : error.message);
    throw error;
  }
};


// Fetch a specific parent by ID

export const getParentById = async (id, headers) => {
  try {
    const response = await api.get(`/api/parents/${id}`,  headers );
    console.log('API Response:', response);
    console.log('Response Data:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error fetching parent by ID:', error.response ? error.response.data : error.message);
    throw error;
  }
};


// Create a new parent
export const createParent = async (parentData, headers) => {
  try {
    const response = await api.post('/api/parents', parentData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error creating parent:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Update an existing parent
export const updateParent = async (id, parentData, headers) => {
  try {
    const response = await api.put(`/api/parents/${id}`, parentData,  headers );
    return response.data;
  } catch (error) {
    console.error('Error updating parent:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete a parent
export const deleteParent = async (id, headers) => {
  try {
    const response = await api.delete(`/api/parents/${id}`,  headers );
    return response.data;
  } catch (error) {
    console.error('Error deleting parent:', error.response ? error.response.data : error.message);
    throw error;
  }
};
